import { styled } from "@pigment-css/react";
import { IconButton } from "@acto/taskpane/field-sales-2/components/primitives/IconButton";
import { Pill } from "@acto/taskpane/field-sales-2/components/primitives/Pill";

// Pill padding is dropped so each 48px button reaches the pill's edge and the whole capsule is
// clickable, rather than only the glyph-sized circles inside it. `HeaderActionPill` gives that up.
export const ActionPill = styled(Pill)(({ theme }) => ({
  padding: 0,
  color: theme.fieldSalesTwo.colors.neutral[900],
  boxShadow: theme.fieldSalesTwo.shadows.glass,
}));

export const ActionPillButton = styled(IconButton)(({ theme }) => ({
  width: theme.fieldSalesTwo.spacing[48],
  height: theme.fieldSalesTwo.spacing[48],
  padding: 0,
  // 20px is the pill icons' Figma size; the doubled class outranks IconButton's 1rem `& svg` default.
  "&& svg": { width: "20px", height: "20px" },
  // Depress 0.96 to match glassCapsulePress, so a pill segment and a standalone glass pill shrink by
  // the same amount; the doubled class outranks IconButton's own `&:active` (0.92), which stays the
  // default for icon buttons outside the header pills.
  "&&:active": { transform: "scale(0.96)" },
  // A segment exactly fills the pill height, so IconButton's offset outline would be drawn
  // outside the capsule. An inset ring is contained by it.
  "&&:focus-visible": {
    outline: "none",
    boxShadow: `inset 0 0 0 ${theme.strokeWidth.regular} ${theme.fieldSalesTwo.colors.neutral[700]}`,
  },
}));

// The kebab (⋮) segment: KebabIcon is intrinsically 18px, so it overrides ActionPillButton's 20px
// outline-glyph size. Shared here rather than re-declared at every kebab call site.
export const ActionPillMenuButton = styled(ActionPillButton)({
  "&& svg": { width: "18px", height: "18px" },
});
